import { render, staticRenderFns } from "./releaseCaseAdmin.vue?vue&type=template&id=6b138686"
import script from "./releaseCaseAdmin.vue?vue&type=script&lang=js"
export * from "./releaseCaseAdmin.vue?vue&type=script&lang=js"
import style0 from "./releaseCaseAdmin.vue?vue&type=style&index=0&id=6b138686&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports